import { INavItem } from '@bssh/comp-lib';
import { ActivatedRoute, Router } from '@angular/router';

export interface RadTabItem extends INavItem {
  selected?: boolean;
}

/**
 * Shared utilities for Radiance rad-tab-group click handling.
 *
 * Radiance web-components v2.9.0 bootstraps Angular Elements with ngZone: "noop",
 * which prevents @Output() EventEmitter emissions from dispatching as DOM CustomEvents.
 * We listen for native (click) instead and walk the Shadow DOM composedPath to find
 * the clicked rad-tab element.
 */
export class RadianceTabUtilities {

  /**
   * Extracts the label of the clicked rad-tab from a native click event
   * by walking event.composedPath() through the Shadow DOM.
   */
  static getTabLabelFromClick(event: any): string {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el.tagName && el.tagName.toLowerCase() === 'rad-tab') {
        return el.getAttribute('label') || el.innerText || '';
      }
    }
    return '';
  }

  /**
   * Handles a click on a rad-tab-group: resolves the clicked tab label,
   * updates the selected state on all tabs, and navigates to the matched route.
   */
  static handleTabClick(
    event: any,
    menuItems: RadTabItem[],
    router: Router,
    route: ActivatedRoute,
    navigationExtras?: object
  ): void {
    var clickedLabel = RadianceTabUtilities.getTabLabelFromClick(event);
    if (!clickedLabel) {
      return;
    }
    menuItems.forEach(function (tab) {
      tab.selected = tab.label.toLowerCase() === clickedLabel.toLowerCase();
      if (tab.selected) {
        router.navigate(tab.route, Object.assign({ relativeTo: route }, navigationExtras || {}));
      }
    });
  }
}
